var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 40,
    viewBox: "0 0 13 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.99951,
    y: -0.000305176,
    width: 1,
    height: 30,
    fill: "#21588C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999512 31.9997L6.49951 38.9997L11.9995 31.9997",
    stroke: "#21588C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingArrowDown);
export default __webpack_public_path__ + "static/media/landingArrowDown.73b76a335637baacf99cb57209eb7326.svg";
export { ForwardRef as ReactComponent };